import axios from "axios";

export const estimateDashboardData = () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/user-dashboard/`)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};

export const userPoReport = (date_gte: string, date_lte: string) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_URL}/user-po-report/?date_gte=` +
        date_gte +
        "&date_lte=" +
        date_lte
    )
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};
